import COMPREHENSION_VALUES from './ComprehensionConstants';

const VALUES = {
    comprehensionValues: COMPREHENSION_VALUES,
};

export default VALUES;
